import React from 'react';
import { Tag, Heading, Lead, PageHero, Section, BtnPrimary } from '../components/UI';
import styles from './Industries.module.css';

const INDUSTRIES = [
  {
    icon: '🏥', t: 'Healthcare',
    tagline: 'Staffing & Software for Healthcare',
    d: 'We provide staffing and software solutions for hospitals, clinics, diagnostic centers, health-tech startups, and pharmaceutical companies. Our expertise covers EHR systems, telemedicine platforms, and specialized clinical staff placement.',
    solutions: ['EHR & Hospital Management Software', 'Medical Staffing & Recruitment', 'Telemedicine Platform Development', 'Healthcare Data Analytics', 'Compliance & Regulatory Support'],
  },
  {
    icon: '🛒', t: 'E-commerce',
    tagline: 'Scalable Platforms for Online Retail',
    d: 'We build scalable e-commerce platforms and supply commerce talent for online retail, marketplace businesses, and D2C brands. From shopping cart solutions to warehouse management, we cover the full e-commerce value chain.',
    solutions: ['Custom E-commerce Platform Dev', 'Payment Gateway Integration', 'Inventory & Order Management', 'E-commerce Staffing', 'Analytics & Personalization'],
  },
  {
    icon: '🎓', t: 'Education',
    tagline: 'EdTech & Education Staffing',
    d: 'We develop EdTech platforms, Learning Management Systems, and provide specialized educational staffing. From K-12 to higher education and corporate training platforms, we deliver solutions that enhance learning outcomes.',
    solutions: ['LMS Development & Integration', 'EdTech Application Development', 'E-learning Content Platforms', 'Educational Staffing', 'Virtual Classroom Solutions'],
  },
  {
    icon: '💰', t: 'Finance',
    tagline: 'Secure Software & Talent for BFSI',
    d: 'We deliver secure, compliant software and specialized financial talent for banks, NBFCs, insurance companies, and fintech startups. Security-first development and thorough regulatory compliance are built into everything we do.',
    solutions: ['Fintech Application Development', 'Core Banking Solutions', 'Risk Management Systems', 'Finance Staffing & Recruitment', 'Regulatory Compliance Tools'],
  },
  {
    icon: '🚚', t: 'Logistics',
    tagline: 'Supply Chain Software & Staffing',
    d: 'We provide supply chain software, fleet and tracking systems, warehouse management platforms, and operations staffing for logistics and transportation companies seeking efficiency and real-time visibility.',
    solutions: ['Fleet Management Systems', 'Warehouse Management Software', 'Real-time Tracking Platforms', 'Logistics Staffing & Operations', 'Route Optimization Tools'],
  },
  {
    icon: '🏠', t: 'Real Estate',
    tagline: 'PropTech & Real Estate Staffing',
    d: 'We build property management platforms, CRM systems, and real estate portals while providing specialized staffing for real estate companies, PropTech startups, and construction firms.',
    solutions: ['Property Management Platforms', 'Real Estate CRM Development', 'Property Listing Portals', 'Real Estate Staffing', 'Virtual Tour & 3D Solutions'],
  },
];

export default function Industries() {
  return (
    <>
      <PageHero
        tag="Industries We Serve"
        title="Deep Expertise Across Six Key Sectors"
        subtitle="We bring domain-specific knowledge to every engagement, delivering software, staffing, and training solutions tailored to each industry's unique challenges and compliance needs."
      />

      {/* ── Industry Cards ──────────────────────────────────────── */}
      <Section variant="paper">
        <div className={styles.industriesGrid}>
          {INDUSTRIES.map((ind, i) => (
            <div key={i} className={styles.indCard}>
              <div className={styles.indHeader}>
                <div className={styles.indIcon}>{ind.icon}</div>
                <div>
                  <div className={styles.indTagline}>{ind.tagline}</div>
                  <h2 className={styles.indTitle}>{ind.t}</h2>
                </div>
              </div>
              <p className={styles.indDesc}>{ind.d}</p>
              <div className={styles.solutions}>
                <div className={styles.solutionsLabel}>Solutions We Provide</div>
                {ind.solutions.map((sol, j) => (
                  <div key={j} className={styles.solutionItem}>
                    <span className={styles.solutionDot} />
                    {sol}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Section>

      {/* ── CTA ────────────────────────────────────────────────── */}
      {/* <Section variant="accent" style={{ textAlign: 'center' }}>
        <Tag light>Work With Us</Tag>
        <Heading light>Don't See Your Industry?</Heading>
        <Lead light style={{ margin: '0 auto 2rem' }}>
          We work across many more sectors. Get in touch and let's discuss how we can help your specific industry.
        </Lead>
        <BtnPrimary to="/contact" style={{ background: '#fff', color: 'var(--accent)' }}>
          Contact Our Team →
        </BtnPrimary>
      </Section> */}
    </>
  );
}
